<template>
    <v-row v-if="$rc.inIndustry('wine')" class="my-1">
        <v-col cols="12">
            <v-alert
                type="error"
                class="shaded-light"
                border="left"
                colored-border
            >
                <div>
                    <slot name="title">
                        <strong>Emerging Carrier Issue</strong>
                        
                        <p
                            style="margin-top: 5px"
                        >
                            We have recently observed some unusual carrier blocking affecting certain bulk messages &mdash; we are working with the major carriers to resolve the issue.  
                            To minimize the potential for any delivery problems <b><u>while we are working with the carriers to resolve this issue</u></b> we recommend adjusting the content of bulk messages 
                            to <b><u>avoid direct (explicit) promotion of alcohol sales or consumption</u></b>.  The carriers have told us that indirect promotion is acceptable.
                        </p>

                        <p>
                            For example, instead of
                        </p>
                        
                        <p
                            style="margin-left: 25px"
                        >
                            Today only, save 25% on all 2022 Cabernet Sauvignons at {website-address}
                        </p> 
                        
                        <p>consider</p>
                        
                        <p
                            style="margin-left: 25px"
                        >
                            Today only, special savings for our members like you.  To learn more: {website-address}
                        </p>

                        For more details <a href="https://redchirp.com/emerging-carrier-issue/" target="_blank">read our article</a> 

                    </slot>
                </div>

            
                <!--<div class="mt-2">
                    <a
                        href="#"
                        @click.prevent="show_details = !show_details"
                    >
                        {{ show_details ? 'Read less' : 'Read more' }}
                        <v-icon color="primary" small>{{ show_details ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </a>
                </div>

                <v-expand-transition>
                    <div
                        v-show="show_details"
                        class="mt-4"
                    >
                        
                    </div>
                </v-expand-transition>-->
            </v-alert>
        </v-col>
    </v-row>
</template>

<script>
/*import WineryCarrierAlertContent from '@/components/bulk/winery-carrier-alert-content.vue';*/

export default {
    name: 'TempDisableWineriesFromScheduling',

    /*components: {
        WineryCarrierAlertContent,
    },*/

    data() {
        return {
            show_details: false,
        };
    },
};
</script>

<style lang="scss" scoped>
a {
    color: var(--v-primary-base) !important;
    text-decoration: none;
}
</style>